import Vue from 'vue'
import App from './App'
import i18n from './i18n'
import store from './store'
import router from './router'
import '@/vab'
import '@/biz'

import goodDetails from './biz/components/GoodDetails'
import CommonConfirm from './biz/components/ServiceMode/CommonConfirm'
import mixinWork from './utils/mixinWork'
import * as filters from './vab/plugins/filters'

Vue.use(goodDetails)
Vue.use(CommonConfirm)
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
Vue.mixin(mixinWork)

// グローバル・リスニングkeydownです
document.addEventListener('keydown', (event) => {
  if (event.key === 'Enter' && event.target.tagName === 'BUTTON') {
    // 黙認を阻止します
    event.preventDefault()
    console.log('Enterキーが押されました')
  }
})

Vue.config.productionTip = false
let vue = new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: (h) => h(App),
})
export default vue
